// src/DatabaseAdmin/Pagination.jsx
import PropTypes from 'prop-types';
import { buildPaginationPages } from '../utils/pagination';
import styles from './Pagination.module.scss';

const MAX_VISIBLE_PAGES = 5;

const Pagination = ({ currentPage, totalPages, onPageChange, loading }) => {
  if (totalPages <= 1) {
    return null;
  }

  const pages = buildPaginationPages({
    currentPage,
    totalPages,
    maxVisiblePages: MAX_VISIBLE_PAGES,
    showEdges: false,
    withEllipsis: false,
  });

  const handleChange = (page) => {
    if (!loading && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <div className={styles.pagination_DatabaseAdmin}>
      <button
        className={`${styles.pageButton_DatabaseAdmin} ${currentPage === 1 || loading ? styles.disabled_DatabaseAdmin : ''}`}
        onClick={() => handleChange(currentPage - 1)}
        disabled={currentPage === 1 || loading}
      >
        Назад
      </button>

      {pages.map((page) => (
        <button
          key={page}
          className={`${styles.pageButton_DatabaseAdmin} ${currentPage === page ? styles.active_DatabaseAdmin : ''}`}
          onClick={() => handleChange(page)}
          disabled={loading}
        >
          {page}
        </button>
      ))}

      <button
        className={`${styles.pageButton_DatabaseAdmin} ${currentPage === totalPages || loading ? styles.disabled_DatabaseAdmin : ''}`}
        onClick={() => handleChange(currentPage + 1)}
        disabled={currentPage === totalPages || loading}
      >
        Вперед
      </button>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default Pagination;
// src/DatabaseAdmin/Pagination.jsx